import { createSelector } from 'reselect';

const invitationsState = (store) => store.apps.teamManagement.invitations;
const organizationState = (store) => store.apps.teamManagement.organization;

const containerSelector = createSelector(
  invitationsState,
  organizationState,
  (filteredState, organization) => ({
    currentPage: filteredState.get('currentPage'),
    invitations: filteredState.get('results'),
    invitationsCount: filteredState.get('count'),
    loading: filteredState.get('loading'),
    selectedFilters: filteredState.get('selectedFilters'),
    selectedInvitations: filteredState.get('selectedInvitations'),
    organizationId: organization.getIn(['organization', 'id']),
  }),
);

const selectedFiltersSelector = createSelector(
  invitationsState,
  (filteredState) => ({
    selectedFilters: filteredState.get('selectedFilters'),
  }),
);

export default containerSelector;
export {
  containerSelector,
  invitationsState,
  selectedFiltersSelector,
};
